import { css } from 'linaria';

export const paddingY = css`
  padding-top: var(--space-200);
  padding-bottom: var(--space-200);
`;

export const paddingX = css`
  padding-left: var(--space-400);
  padding-right: var(--space-400);

  @media (--to-tablet) {
    padding-left: var(--space-300);
    padding-right: var(--space-300);
  }
`;

export const hoverLayout = css`
  position: relative;

  @media (hover: hover) {
    &:hover {
      &::after {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: var(--background-secondary);
        z-index: -1;
        top: 0;
      }
    }
  }
`;

export const focusLayout = css`
  position: relative;

  &::after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: var(--background-secondary);
    z-index: -1;
    top: 0;
  }
`;
